import {DateTime} from 'luxon';
import {WorkingTime} from '../state/types/WorkingTime';

/**
 * A working time belongs to the day of its start, and both ends of a filter range are inclusive.
 *
 * The date pickers only change the day of a value and keep its time of day, so the boundaries have
 * to be normalised with startOfFilterDay()/endOfFilterDay(). Otherwise the first and the last day
 * of the range would only be covered from/until the time of day the range was initialised with.
 */
export const isWithinRange = (workingTime: WorkingTime, start: DateTime, end: DateTime): boolean =>
    start.toJSDate() <= workingTime.start && workingTime.start <= end.toJSDate();

export const startOfFilterDay = (date: DateTime | null): DateTime | null =>
    date ? date.startOf('day') : date;

export const endOfFilterDay = (date: DateTime | null): DateTime | null =>
    date ? date.endOf('day') : date;

/**
 * Number of days a range covers, both days included - matches the backend export validation.
 */
export const rangeInDays = (start: DateTime, end: DateTime): number =>
    Math.floor(end.startOf('day').diff(start.startOf('day'), 'days').days) + 1;
